/**
 * Parametri Adobe/Chrome per l'anteprima PDF multipagina in iframe/embed:
 * toolbar e scrollbar visibili, FitH per scroll continuo di tutte le pagine.
 */
export function withPdfPreviewParams(url) {
  if (!url) return url;
  const params = "toolbar=1&navpanes=1&scrollbar=1&view=FitH";
  return `${String(url).split("#")[0]}#${params}`;
}
